import React, { createContext, ReactNode, useContext } from 'react';

const CarouselTitleSlotContext = createContext<string | undefined>(undefined);

type CarouselTitleSlotProviderProps = {
  carouselId: string;
  children: ReactNode;
};

/** Identifies a hosted carousel so a remote theme can replace this title independently. */
export function CarouselTitleSlotProvider({ carouselId, children }: CarouselTitleSlotProviderProps): JSX.Element {
  return <CarouselTitleSlotContext.Provider value={carouselId}>{children}</CarouselTitleSlotContext.Provider>;
}

export const useCarouselTitleSlotId = (): string | undefined => useContext(CarouselTitleSlotContext);
